/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface GetBeamShapingGroupDto
 */
export interface GetBeamShapingGroupDto {
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof GetBeamShapingGroupDto
     */
    taskType: TaskTypeDescription;
    /**
     * 
     * @type {number}
     * @memberof GetBeamShapingGroupDto
     */
    radiationFieldShapeId: number;
    /**
     * 
     * @type {string}
     * @memberof GetBeamShapingGroupDto
     */
    $type?: GetBeamShapingGroupDtoTypeEnum;
}


/**
 * @export
 */
export const GetBeamShapingGroupDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoGetBeamShapingGroupDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.GetBeamShapingGroupDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type GetBeamShapingGroupDtoTypeEnum = typeof GetBeamShapingGroupDtoTypeEnum[keyof typeof GetBeamShapingGroupDtoTypeEnum];



/**
 * Check if a given object implements the GetBeamShapingGroupDto interface.
 */
export function instanceOfGetBeamShapingGroupDto(value?: unknown): value is GetBeamShapingGroupDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(GetBeamShapingGroupDtoTypeEnum)[0];
}

export function GetBeamShapingGroupDtoFromJSON(json: any): GetBeamShapingGroupDto {
    return GetBeamShapingGroupDtoFromJSONTyped(json, false);
}

export function GetBeamShapingGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBeamShapingGroupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'taskType': TaskTypeDescriptionFromJSON(json['taskType']),
        'radiationFieldShapeId': json['radiationFieldShapeId'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function GetBeamShapingGroupDtoToJSON(value?: GetBeamShapingGroupDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'taskType': TaskTypeDescriptionToJSON(value['taskType']),
        'radiationFieldShapeId': value['radiationFieldShapeId'],
        '$type': value['$type'],
    });
}

